import React, { ComponentType } from 'react';
import { inject, observer } from 'mobx-react';
import './homePageHeader.module.scss';
import { ReservableSlotCard } from '../../molecules/reservable/home/ReservableSlotCard';
import { routingStore } from '../../../../common/stores/routing';
import { V3Routes } from '../../../routes';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { TokenType } from '../../../../commonv3/types/tokens';
import moment from 'moment-timezone';
import { SessionType } from '../../../types/sessions';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { MonthlyGoalCard } from '../../molecules/goals/home/MonthlyGoalCard';
import { ToolTip } from '../../atoms/tooltips/ToolTip';
import { Button, ButtonType } from '../../../../commonv3/components/atoms/buttons/Button';
import { withNavigation } from '../../hocs/withNavigation';
import { NavigationSpecs } from '../../../states/NavigationState';
import { MultiCreatorReservableSlotCard } from '../../molecules/reservable/home/MultiCreatorReservableSlotCard';

type ButtonProps = {
    id: string;
    type?: ButtonType;
    loading: boolean;
    onReservationClick: () => any;
};

const ReservationButton = ({ id, loading, type = 'primary', onReservationClick }: ButtonProps) => {
    return (
        <Button id={id} styleName="button" type={type} size="s" loading={loading} onClick={onReservationClick}>
            予約する
        </Button>
    );
};

type Props = {
    homeState: HomePageState;
};

@withNavigation(NavigationSpecs.home('white'))
@inject('homeState')
@observer
export class HomePageHeaderClass extends React.Component<Props> {
    closeCoachingTooltip = () => {
        this.props.homeState.closeCoachingTooltip();
        GlobalStatesV3.routing.push(V3Routes.home());
    };
    coachingReservationClick = () => {
        this.props.homeState.closeCoachingTooltip();
        if (GlobalStatesV3.currentUser.preference.coachingV2IntroductionCompleted) {
            routingStore.push(V3Routes.coachingSessions());
        } else {
            routingStore.push(V3Routes.coachingSessionsIntroduction());
        }
    };
    render() {
        const { reservationList } = this.props.homeState;
        const { availableTokens, loadState } = GlobalStatesV3.currentUser;
        const { coachingTooltipClosed } = GlobalStatesV3.currentUser.preference;
        const coachingToken = availableTokens.findAffordableToken(TokenType.GROUP_COACHING, 1, moment());
        const nextCoachingToken = availableTokens.findAffordableToken(
            TokenType.GROUP_COACHING,
            1,
            moment().add(1, 'month')
        );
        const mokumokuToken = availableTokens.findAffordableToken(TokenType.MOKUMOKU, 1, moment());
        const nextMokumokuToken = availableTokens.findAffordableToken(TokenType.MOKUMOKU, 1, moment().add(1, 'month'));
        const loading = loadState.submitting;
        const chooseCoaching = ['coaching'].find((needle) => routingStore.location.pathname.includes(needle)) != null;
        const currentUser = GlobalStatesV3.currentUser;
        return (
            <div styleName="home-page-header">
                <MonthlyGoalCard loading={loading} onDetailClick={() => routingStore.push(V3Routes.goals())} />
                <div styleName="reservables">
                    <ReservableSlotCard
                        title="コーチング"
                        currentToken={coachingToken}
                        nextToken={nextCoachingToken}
                        reservationList={reservationList.findSessionReservationsByType(SessionType.GROUP_COACHING)}
                        actionButton={
                            <ToolTip
                                id="coaching-tooltip"
                                title="まずはコーチングを予約しよう"
                                description="継続して学習効率を上げるために、目標設定を行いましょう。"
                                onClose={this.closeCoachingTooltip}
                                opened={chooseCoaching && !coachingTooltipClosed}
                            >
                                <ReservationButton
                                    id={'coaching-reserve-button'}
                                    loading={loading}
                                    onReservationClick={this.coachingReservationClick}
                                />
                            </ToolTip>
                        }
                    />
                    <ReservableSlotCard
                        title="もくもく会"
                        currentToken={mokumokuToken}
                        nextToken={nextMokumokuToken}
                        reservationList={reservationList.findSessionReservationsByType(SessionType.MOKUMOKU)}
                        actionButton={
                            <ReservationButton
                                id={'mokumoku-reserve-button'}
                                loading={loading}
                                onReservationClick={() => routingStore.push(V3Routes.sessions(SessionType.MOKUMOKU))}
                            />
                        }
                    />
                    {currentUser.hasEnabledFlagKey('multicreator_ph2') &&
                        currentUser.isMultiCreatorUser() && (
                            <MultiCreatorReservableSlotCard
                                title="1on1キャリアコーチング"
                                reservationList={reservationList.findSessionReservationsByType(
                                    SessionType.MULTICREATOR_CAREER_COACHING
                                )}
                                actionButton={
                                    <ReservationButton
                                        id={'career-coaching-reserve-button'}
                                        loading={loading}
                                        type="multicreator"
                                        onReservationClick={() => routingStore.push(V3Routes.careerCoachingSessions())}
                                    />
                                }
                            />
                        )}
                </div>
            </div>
        );
    }
}

export const HomePageHeader = HomePageHeaderClass as ComponentType<{}>;
